import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

import { type CodeMessageResponse } from '../types';
import { zodCodeMessageResponseSchema } from '../validations';

import {
  type RunContactPointPayload,
  zodRunContactPointPayloadSchema,
} from './validations';

/**
 * Manually runs a contact point for the given delivery note asset ids, bypassing
 * the subscription filter. Runs asynchronously; the result lands in the execution log.
 *
 * @param contactPointId - The id of the contact point to run.
 * @param payload - The delivery note asset ids to run the contact point for.
 * @returns A promise that resolves with the API response.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Data-Subscription
 */
export const runContactPoint = async (
  contactPointId: UUID,
  payload: RunContactPointPayload,
): Promise<CodeMessageResponse> => {
  const response = await vestigasApi
    .post(ENDPOINT.DATA_SUBSCRIPTION.RUN_CONTACT_POINT(contactPointId), {
      json: payload,
      validate: {
        body: zodRunContactPointPayloadSchema,
      },
    })
    .json<CodeMessageResponse>();

  const validated = zodCodeMessageResponseSchema.safeParse(response);

  if (!validated.success) {
    console.warn(
      '[runContactPoint] Response validation failed',
      validated.error,
    );
    return response;
  }

  return validated.data;
};
